import React, { useCallback, useState, useEffect, useRef } from 'react';
import style from './MyHospitalDisconnect.module.css';
import { useNavigate } from 'react-router-dom';
import URL from '../../../../constants/url';
import Modal from "../../../../components/comm/Modal"
import AlertBox from '../../../../components/box/AlertBox';

import HeadSub from '../../../../components/comm/HeadSub';
import ConfirmBox from '../../../../components/box/ConfirmBox';
import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';


const MyHospitalDisconnect = () => {

    const navigate = useNavigate();
    const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
    const [selectedHospitals, setSelectedHospitals] = useState([]);

    // modal
    const [isOpen, setIsOpen] = useState(false);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [selectedHsptlNm, setSelectedHsptlNm] = useState("");
    const [confirmMessage, setConfirmMessage] = useState("");


    const getClnicInfo = useCallback(async (selectedHospitals) => {

        const url = "/hsptl/deleteHsptlDisconnectInfo";
        const jToken = localStorage.getItem('jToken');
        const reqParam = {
            usrInfoId : loginUser.usrInfoId,
            cnncHsptlCd : selectedHospitals.map(h => h.hsptlCd)
        }

        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
            , withCredentials: true
        }

        await axiosApi.post(url, reqParam, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {

                const filteredHospitals = loginUser.usrHsptlMap.filter(hospital => {
                    return !selectedHospitals.some(selected => selected.hsptlCd === hospital.cnncHsptlCd);
                });

                // 새로운 배열에 순서대로 hsptlSortOrdr를 1부터 다시 정의
                const updatedHospitals = filteredHospitals.map((hospital, index) => {
                    return { ...hospital,
                        hsptlSortOrdr: index + 1
                    };
                });

                loginUser.usrHsptlMap = updatedHospitals;

                sessionStorage.removeItem("loginUser");
                sessionStorage.setItem("loginUser", JSON.stringify(loginUser));

                setIsAlertOpen(true);

            } else {
                alert(res.data.resultMessage);
            }
        })
        .catch(err => {
            console.error("사용자의료건강정보 호출 중 오류  : ", err);
        })

    }, []);

    const completeClose = () => {
        setIsAlertOpen(false);
        // navigate(URL.MY_HOSPITAL_SETTING);
        navigate(-2);
    }

    const handleClose = (chooseAt) => {
        if(chooseAt){
            getClnicInfo(selectedHospitals);
        }
        setIsOpen(false)
    }

    const hsptlDisconnect = () => {
        if(selectedHospitals.length > 0){
            let msg = "";
            selectedHospitals.map((item, index)=>{
                msg += item.hsptlNm
                if((selectedHospitals.length-1) != index){
                    msg += ", "
                }
            })
            setIsOpen(true)
            setSelectedHsptlNm(msg);
        }
    }


    return (
        <>
            <HeadSub title="병원 연결 해제" />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap'>

                    <div className={style['content-box']}>
                        <div className={style['top-txt']}>
                            <span> 연결 해제할 병원을 <b>모두</b> 선택해주세요 <br />
                                단, 대표 병원으로 설정된 병원은 해제가 불가합니다.
                            </span>
                        </div>

                        {
                            loginUser.usrHsptlMap.map((item) => {
                                if (item.hsptlSortOrdr === 1) {
                                    return (
                                        <div className={style['main-select-box']}>
                                            <p>{item.cnncHsptlNm}</p>
                                            <span className={style['main-mark']}>대표 병원</span>
                                        </div>
                                    )
                                }
                            })
                        }


                        <div className={style['select-list-box']}>
                            <p>병원 선택</p>
                            <ul>
                                {
                                    loginUser.usrHsptlMap.map((item) => {
                                        if (item.hsptlSortOrdr !== 1) {
                                            return (
                                                <li>
                                                    <div className='chkbox-custom' data-chkbox='list-btn'>
                                                        <input
                                                            type="checkbox"
                                                            id={"hospital_" + item.hsptlSortOrdr}
                                                            checked={selectedHospitals.some(h => h.hsptlCd === item.cnncHsptlCd)}
                                                            onChange={(e) => {
                                                                const isChecked = e.target.checked;
                                                                setSelectedHospitals((prev) => {
                                                                    if (isChecked) {
                                                                        return [...prev, { hsptlCd: item.cnncHsptlCd, hsptlNm: item.cnncHsptlNm }];
                                                                    } else {
                                                                        return prev.filter(h => h.hsptlCd !== item.cnncHsptlCd);
                                                                    }
                                                                });
                                                            }}
                                                        />
                                                        <label htmlFor={"hospital_" + item.hsptlSortOrdr}>
                                                            <span>{item.cnncHsptlNm}</span>
                                                        </label>
                                                    </div>
                                                </li>
                                            )
                                        }
                                    })
                                }
                            </ul>
                        </div>

                        <div className="bottom-fixed-box" data-border-line="top">
                            <div className="inner-box">

                                <div className='btn-layout' data-btn-num="2">
                                    <button className="btn" data-btn-type="outline-main" data-btn-size="lg" onClick={() => navigate(-1)}>
                                        <span>취소</span>
                                    </button>
                                    <button className="btn" data-btn-type="fill-main" data-btn-size="lg" disabled={selectedHospitals.length == 0 && 'disabled'} onClick={hsptlDisconnect}>
                                        <span>선택 완료</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>


            <AlertBox
                isOpen={isAlertOpen}
                onClose={completeClose}
                message={selectedHsptlNm+" 연결이 해제되었습니다."}
                btnTxt='확인'
            />

            <ConfirmBox isOpen={isOpen}
                setIsOpen={setIsOpen}
                onCloseCallback={handleClose}
                message={selectedHsptlNm+" 연결을 해제하시겠습니까?"}
                ConfirmMessage
                leftBtnTxt={'아니오'}
                rightBtnTxt={'네'} 
            >
                <div className={style['modal-sub-box']}>
                    <span>연결 해제 시 해당 병원의 서비스 이용이 제한됩니다.</span>
                </div>
                
            </ConfirmBox>

        </>
    );
};

export default MyHospitalDisconnect;
